export default {
    AUSENTE_A: 1,
    EXTRAIDO_E: 2,
    HIGIDO_H: 3,
    HIGIDO_SELADO_HS: 4,
    PROTESE_PARCIAL_REMOVIVEL: 5,
    PROTESE_TEMPORARIA: 6,
    INCLUSO_I: 7,
    PROTESE_CORONARIA_UNITARIA: 8,
    COROA_CO: 9,
    IMPLANTE: 10,
    PILAR_P: 11,
    NUCLEO_PINO: 12,
    RESTO_RADICULAR_RR: 13,
    RETRACAO_GENGIVAL_RG: 14,
    CALCULO_DENTAL_CD: 15,
    EXTRACAO_INDICADA_EI: 16,
    SELANTE_INDICADO_SI: 17,
    FRATURA_FR: 18,
    MANCHA_BRANCA_ATIVA_M: 19,
    CARIADO_C: 20,
    RESTAURADO_R: 21,
    CARIE_DA_RAIZ: 22,
    RESTAURADO_COM_CARIE_RC: 23,
    RAIZ_RESTAURADA: 24,
    NECESSITA_DE_TRATAMENTO_ENDODONTICO: 25,
    POSSUI_LESAO_DE_FURCA: 26,
    TRATAMENTO_ENDODONTICO_REALIZADO: 27,
    LESAO_DE_FURCA_TRATADA: 28,
    MANTENEDOR_DE_ESPACO_ME: 29,
}